<template>
    <div class="task-close">
        <div v-if="tasks" class="task-grid">
            <div v-for="task in tasks" :key="task._id" class="task-card">
                <div v-if="task.attachments.length > 0" class="task-card__image" @click="view(task)">
                    <img
                        :src="task.attachments[0].v2Format && task.attachments[0].cdnUrl
                            ? task.attachments[0].cdnUrl
                            : `https://static.supsis.live/${task.attachments[0].path + task.attachments[0]._id}.${task.attachments[0].ext}`"
                        alt="attachment"
                    />
                </div>
                <div class="task-card__content" @click="view(task)">
                    <div class="task-card__header">
                        <h3 class="task-card__title" @click="view(task)">{{ task.title }}</h3>
                        <a-popover
                            @click.stop="handleInnerClick($event, task)"
                            overlayClassName="task-more-options"
                            trigger="click"
                            placement="bottomRight"
                            :visible="task.showPopover"
                            @visibleChange="handlePopoverChange($event, task)"
                        >
                            <template #content>
                                <div v-for="(action, index) of filteredActions" :key="index">
                                    <div class="task-card__action" @click="runAction(action.action, task)">
                                        <span class="material-icons">{{ action.icon }}</span>
                                        {{ action.text }}
                                    </div>
                                </div>
                            </template>
                            <span class="task-card__more material-icons">more_vert</span>
                        </a-popover>
                    </div>
                    <div class="task-card__tags">
                        <span
                            v-for="tag in task.tags"
                            :key="tag._id"
                            :style="getTagStyle(tag.color)"
                            class="task-card__tag"
                            v-tippy="{ content: tag.name, placement: 'top' }"
                        >
                            {{ tag.name }}
                        </span>
                    </div>
                    <div class="task-card__details">
                        <div class="task-card__users">
                            <Avatar
                                v-for="userId in getAssigneesUserId(task).slice(0, 2)"
                                :key="userId"
                                :size="25"
                                :src="users[userId] && users[userId].gravatar"
                                :username="users[userId] && users[userId].name"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    content: users[userId] && users[userId].email,
                                }"
                            />
                            <span v-if="getAssigneesUserId(task).length > 2" class="task-card__users-more">
                                +{{ getAssigneesUserId(task).length - 2 }}
                            </span>
                        </div>
                        <div class="task-card__priority">
                            <component :is="getPriorityIcon(task.priority)" />
                        </div>
                    </div>
                    <div class="task-card__meta">
                        <div class="task-card__meta-item" v-if="(task.subTasks || []).length > 0">
                            <span class="material-icons">account_tree</span>
                            {{ getCompletedParentTaskCount(task) }}/{{ (task.subTasks || []).length }}
                        </div>
                        <div class="task-card__meta-item" v-if="task.checklist.length > 0">
                            <span class="material-icons">library_add_check</span>
                            {{ getCompletedChecklistCount(task) }}/{{ task.checklist.length }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="tasks && tasks.length === 0"
            style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 500px;
                align-content: center;
                align-items: center;
            "
        >
            <NotDataIcon style="width: 200px; height: 200px" />
            <p style="color: #ec4b1d; font-weight: bold; font-size: 20px; margin-top: 24px; margin-left: 20px">
                Kapatılmış Task Bulunamadı
            </p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import LowIcon from "../../svg/task/LowIcon.vue";
import LowestIcon from "../../svg/task/LowestIcon.vue";
import MediumIcon from "../../svg/task/MediumIcon.vue";
import HighIcon from "../../svg/task/HighIcon.vue";
import HighestIcon from "../../svg/task/HighestIcon.vue";
import Avatar from "vue-avatar";
import NotDataIcon from "../../../../src/views/Pages/Chatbot/pages/integrations/svg/NotDataIcon.vue";
import { publishMessage, SystemMessageTypes } from "../../../utils/systemPubSub";

export default {
    name: "TaskClose",
    props: {
        workflow: String,
    },
    components: {
        Avatar,
        LowIcon,
        LowestIcon,
        MediumIcon,
        HighIcon,
        HighestIcon,
        NotDataIcon,
    },
    data() {
        return {
            tasks: null,
            selected: false,
            relations: {},
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        filteredActions() {
            return this.actions.filter(action => this.isShowingAction(action));
        },
        actions() {
            const actions = [
                {
                    icon: "edit",
                    text: this.$t("settings.edit"),
                    action: "edit",
                },
                {
                    icon: "delete",
                    text: this.$t("chatbotv2.delete"),
                    action: "deleteTaskModalOpen",
                },
                {
                    icon: "archive",
                    text: "Görevi Panoya Taşı",
                    action: "notCompleted",
                },
            ];

            if (this.pipeline && this.pipeline.type === "completed") {
                actions.push({
                    icon: "check_circle",
                    text: "Görevi Kapat",
                    action: "confirmModelOpen",
                });
            }

            return actions;
        },
    },
    methods: {
        ...mapActions({
            getDoneTasks: "tasks/getDoneTasks",
            addNewWindow: "app/addNewWindow",
            deleteTask: "tasks/deleteTask",
            doneTask: "tasks/doneTask",
            removeFromDoneTasks: "tasks/removeFromDoneTasks",
            getTasks: "tasks/getTasks",
        }),
        fetch() {
            this.getDoneTasks({ workflowId: this.workflow })
                .then((tasks) => {
                    this.tasks = tasks.map((task) => ({ ...task, showPopover: false }));
                })
                .catch((error) => {
                    console.error("Error fetching done tasks:", error);
                    this.$notification.error({
                        message: "Hata",
                        description: "Görevler yüklenirken bir hata oluştu",
                    });
                });
        },
        getAssigneesUserId(item) {
            return _.uniq([item.assignees].flat()).filter((c) => this.users[c]);
        },
        getCompletedParentTaskCount(item) {
            return (item.subTasks || []).filter((item) => item.completed).length;
        },
        getCompletedChecklistCount(item) {
            return item.checklist.filter((item) => item.isCompleted).length;
        },
        view(item) {},
        edit(task) {
            const workflow = this.workflows[this.workflow];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask"].map(
                (permission) => workflow.permissions[permission]
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[1].includes(this.user._id)) {
                this.addNewWindow({
                    type: "editor-task",
                    title: task.title,
                    payload: {
                        taskId: task._id,
                    },
                });
            } else {
                this.addNewWindow({
                    type: "preview-task",
                    title: task.title,
                    payload: {
                        taskId: task._id,
                    },
                    footer: false,
                });
            }
            task.showPopover = false;
        },
        deleteTaskModalOpen(task) {
            this.deleteTask(task)
                .then(() => {
                    this.$notification.success({
                        message: "Başarılı",
                        description: "Görev silindi",
                    });
                    this.tasks = this.tasks.filter((t) => t._id !== task._id);
                })
                .catch(() => {
                    this.$notification.error({
                        message: "Hata",
                        description: "Görev silinirken bir hata oluştu",
                    });
                });
            task.showPopover = false;
        },
        confirmModelOpen(task) {
            this.$emit("confirm-item", task);
            task.showPopover = false;
        },
        notCompleted(task) {
            this.removeFromDoneTasks(task._id)
                .then(() => {
                    publishMessage(SystemMessageTypes.TASK_MOVED_BOARD, {
                        task,
                        workflowId: this.workflow,
                    });
                    this.$notification.success({
                        message: "Başarılı",
                        description: "Görev panoya taşındı",
                    });
                    this.tasks = this.tasks.filter((t) => t._id !== task._id);
                })
                .catch(() => {
                    this.$notification.error({
                        message: "Hata",
                        description: "Görev panoya taşınırken bir hata oluştu",
                    });
                });
        },
        isShowingAction(action) {
            return (
                !action?.type ||
                (action.type === "goto_message" && this.relations["message"]) ||
                (action.type === "goto_chat" && this.relations["conversation"]) ||
                (action.type === "goto_visitor" && this.relations["visitor"])
            );
        },
        gotoMessage(task) {
            task.showPopover = false;
        },
        gotoChat(task) {
            task.showPopover = false;
        },
        showVisitor(task) {
            this.addNewWindow({
                type: "show-visitor",
                payload: {
                    visitorId: this.relations["visitor"].visitor,
                },
                footer: false,
            });
            task.showPopover = false;
        },
        runAction(fnName, task) {
            event?.stopPropagation();

            if (fnName === "notCompleted") {
                this[fnName](task);
                return;
            }

            task.showPopover = false;
            this[fnName](task);
        },
        handleInnerClick(event, task) {
            event.stopPropagation();
            this.tasks.forEach((t) => {
                if (t._id !== task._id) {
                    t.showPopover = false;
                }
            });
            task.showPopover = !task.showPopover;
        },
        handlePopoverChange(visible, task) {
            task.showPopover = visible;
        },
        getTagStyle(color) {
            return {
                backgroundColor: this.lightenColor(color, 0.5),
                color: color,
            };
        },
        lightenColor(color, percent) {
            if (!color) {
                return "#ffffff";
            }
            const num = parseInt(color.replace("#", ""), 16),
                amt = Math.round(2.55 * percent * 100),
                R = (num >> 16) + amt,
                G = ((num >> 8) & 0x00ff) + amt,
                B = (num & 0x0000ff) + amt;
            return (
                "#" +
                (
                    0x1000000 +
                    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                    (B < 255 ? (B < 1 ? 0 : B) : 255)
                )
                    .toString(16)
                    .slice(1)
            );
        },
        getPriorityIcon(priority) {
            switch (priority) {
                case "low":
                    return LowIcon;
                case "lowest":
                    return LowestIcon;
                case "medium":
                    return MediumIcon;
                case "high":
                    return HighIcon;
                case "highest":
                    return HighestIcon;
                default:
                    return LowIcon;
            }
        },
    },
    created() {
        this.fetch();
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
.task-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.task-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }

    &--selected {
        border: 2px solid var(--pipeline-color);
    }

    &__image {
        height: 150px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__content {
        padding: 16px;
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 12px;
    }

    &__title {
        font-size: 18px;
        font-weight: 600;
        margin: 0;
        cursor: pointer;
    }

    &__more {
        cursor: pointer;
        color: #91a2b6;
    }

    &__tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
    }

    &__tag {
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
    }

    &__details {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }

    &__users {
        display: flex;
        align-items: center;

        .vue-avatar {
            margin-right: -8px;
            border: 2px solid #fff;
        }
    }

    &__users-more {
        background-color: #e0e0e0;
        color: #555;
        font-size: 12px;
        font-weight: 600;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 4px;
    }

    &__priority {
        svg {
            width: 20px;
            height: 20px;
        }
    }

    &__meta {
        display: flex;
        gap: 12px;
    }

    &__meta-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        color: #555;

        .material-icons {
            font-size: 16px;
        }
    }

    &__action {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: #f1f3f9;
        }

        .material-icons {
            font-size: 18px;
            color: #91a2b6;
        }
    }
}

.task-more-options {
    .ant-popover-inner-content {
        padding: 0;
    }
}
</style>
